import React, { useState, useEffect, useRef } from 'react';
import '../Pagina.css';
import './Video.css';
//import '../Animate/animate.css';

import { /*reqGET,*/ set_language, content_language, repo_img_link/*, translate*/} from '../../../Utils'

//import { language } from '../WEBContent/Language';

import Loader from '../../../loader';

const Video = (props) => {

    const [/*lang*/, set_lang] = useState('pt');
    const [/*lang_id*/, set_lang_id] = useState('1');

    const [, set_dados] = useState(null);
	const banner = useRef(null);

    const [isloading, setLoading] = useState(true);

    const [navbarHeight, setnavbarHeight] = useState(0);
    const [sliderMarginTop, setSliderMarginTop] = useState(0);
    const [vhHeight, setvhHeight] = useState('100vh');

    useEffect(() => {

        if(props.dados_banner !== undefined && props.dados_banner !== null && props.dados_banner !== '') {
            set_dados(banner.current = props.dados_banner)

            // setvhHeight(props.dados_height.vh_height + 'vh')
            // setSliderMarginTop(props.dados_height.margin_top)
            // setnavbarHeight(props.dados_height.navbar_height)
        }

        function getNavbarHeight() {
            setTimeout(() => {
                let height = 0;
                let marginTop = 0;
                let windowWidth = window.innerWidth;
                
                if(document.getElementsByClassName('sticky-top').length > 0) {
                    height = document.getElementsByClassName('sticky-top')[0].clientHeight;
                } else {
                    if(windowWidth < 992) {
                        height = marginTop = document.getElementsByClassName('fixed-top')[0].clientHeight;
                    } else {
                        height = 0;
                    }
                }
               
                setnavbarHeight(height);
                setSliderMarginTop(marginTop);

                if(windowWidth < 992) {
                    setvhHeight('80svh');
                } else {
                    if(document.getElementsByClassName('page-01').length > 0) {
                        setvhHeight('100vh');
                    } else if(document.getElementsByClassName('page-02').length > 0) {
                        setvhHeight('70vh');
                    } else if(document.getElementsByClassName('page-03').length > 0) {
                        setvhHeight('85vh');
                    } else if(document.getElementsByClassName('page-04').length > 0) {
                        setvhHeight('100vh');
                    } else if(document.getElementsByClassName('page-05').length > 0) {
                        setvhHeight('100vh');
                    } else {
                        setvhHeight('100vh');
                    }
                }
                
            }, 350)
        }

        window.addEventListener('resize', getNavbarHeight);
        getNavbarHeight();

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

        setLoading(false)

        /*
        getInfo()
            .then((res) => {
                set_dados(banner.current = res)

                setTimeout(() => {
                    setLoading(false)
                }, 750)

            })
        */
    }, [props])

    return (
        isloading ?
            <div id="hero_video">
                <div className='ratio ratio-16x9'>
                    <Loader />
                </div>
            </div>
		:
            <>

                <section id="hero_video" style={{marginTop: sliderMarginTop + "px"}}>
                    <div className={"ratio ratio-16x9"} style={{ height: "calc(" + vhHeight + " - " + navbarHeight + "px)" }}>
                        <video className="object-fit-cover" poster="" preload="auto" autoPlay muted playsInline loop >
                            <source src={repo_img_link("hero_video.mp4")} type="video/mp4" />
                        </video>
                        <div className='video-caption-container'>
                            <h2 className='video-caption-title'>alimentação com qualidade de vida!</h2>
                        </div>
                    </div>
                </section>

            </>
    )
};
export default Video;